import axios from '../../config/axios';
import getEnv from '../getEnv';

const context = getEnv('extrato');

export default {
  transactionsByDate: async ({
    tokenCard,
    numberAccount,
    startDate,
    endDate,
    page,
    itemsPerPage,
  }) => {
    let data;
    try {
      const response = await axios.get(
        `${context}/extract/v2/transactionsbydaterange/${tokenCard}/${numberAccount}/${startDate}/${endDate}/${page}/${itemsPerPage}`,
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
};
